export interface QuestionBase {
  id: string;
  section: number;
  sectionName: string;
  text: string;
  required: boolean;
  sensitive?: boolean;
}

export interface MultiSelectQuestion extends QuestionBase {
  type: 'multi-select';
  options: string[];
}

export interface SingleSelectQuestion extends QuestionBase {
  type: 'single-select';
  options: string[];
}

export interface ScaleQuestion extends QuestionBase {
  type: 'scale';
  min: number;
  max: number;
  minLabel: string;
  maxLabel: string;
}

export type Question = MultiSelectQuestion | SingleSelectQuestion | ScaleQuestion;

export const questions: Record<string, Question> = {
  Q1: {
    id: 'Q1',
    type: 'multi-select',
    section: 1,
    sectionName: '목표',
    text: '오늘 가장 개선하고 싶은 고민은?',
    required: true,
    options: ['건조·당김', '모공·피지', '색소·톤', '홍조·민감', '탄력·주름', '트러블·여드름'],
  },
  Q2: {
    id: 'Q2',
    type: 'single-select',
    section: 1,
    sectionName: '목표',
    text: '케어 목표 기간은?',
    required: false,
    options: ['1개월 이내', '3개월', '6개월 이상', '특별 이벤트 대비'],
  },
  Q3: {
    id: 'Q3',
    type: 'single-select',
    section: 1,
    sectionName: '목표',
    text: '원하는 관리 강도는?',
    required: false,
    options: ['순한 유지', '표준', '집중'],
  },
  Q4: {
    id: 'Q4',
    type: 'single-select',
    section: 2,
    sectionName: '생활·환경',
    text: '하루 자외선(실외) 노출 시간은?',
    required: false,
    options: ['거의 없음', '1~2시간', '3시간 이상'],
  },
  Q5: {
    id: 'Q5',
    type: 'single-select',
    section: 2,
    sectionName: '생활·환경',
    text: '자외선차단제 사용 빈도는?',
    required: false,
    options: ['매일', '가끔', '사용 안 함'],
  },
  Q6: {
    id: 'Q6',
    type: 'single-select',
    section: 2,
    sectionName: '생활·환경',
    text: '주 생활환경의 건조함(냉난방)은?',
    required: false,
    options: ['심함', '보통', '약함'],
  },
  Q7: {
    id: 'Q7',
    type: 'scale',
    section: 2,
    sectionName: '생활·환경',
    text: '최근 스트레스 정도는?',
    required: false,
    min: 1,
    max: 5,
    minLabel: '낮음',
    maxLabel: '높음',
  },
  Q8: {
    id: 'Q8',
    type: 'single-select',
    section: 2,
    sectionName: '생활·환경',
    text: '평균 수면 시간은?',
    required: false,
    options: ['6시간 미만', '6~8시간', '8시간 이상'],
  },
  Q9: {
    id: 'Q9',
    type: 'single-select',
    section: 2,
    sectionName: '생활·환경',
    text: '흡연 여부는?',
    required: false,
    options: ['비흡연', '가끔', '매일'],
  },
  Q10: {
    id: 'Q10',
    type: 'single-select',
    section: 3,
    sectionName: '직업군',
    text: '주 근무 환경은?',
    required: false,
    options: ['실내 사무', '실외·야외', '매장·서비스', '의료·화학', '주방·고열', '교대근무'],
  },
  Q11: {
    id: 'Q11',
    type: 'multi-select',
    section: 3,
    sectionName: '직업군',
    text: '해당하는 노출은?',
    required: false,
    options: ['마스크 4시간 이상', '화면(블루라이트) 6시간 이상', '잦은 물·세정 접촉', '해당 없음'],
  },
  Q12: {
    id: 'Q12',
    type: 'single-select',
    section: 4,
    sectionName: '관리 패턴',
    text: '현재 홈케어 단계 수는?',
    required: false,
    options: ['1~2단계', '3~4단계', '5단계 이상'],
  },
  Q13: {
    id: 'Q13',
    type: 'single-select',
    section: 4,
    sectionName: '관리 패턴',
    text: '각질·필링 주기는?',
    required: false,
    options: ['안 함', '월 1~2회', '주 1회 이상'],
  },
  Q14: {
    id: 'Q14',
    type: 'multi-select',
    section: 4,
    sectionName: '관리 패턴',
    text: '사용 중인 기능성 성분은?',
    required: false,
    options: ['비타민C', '레티놀', '나이아신아마이드', 'AHA·BHA', '히알루론산', '없음'],
  },
  Q15: {
    id: 'Q15',
    type: 'single-select',
    section: 4,
    sectionName: '관리 패턴',
    text: '에스테틱·피부과 방문 주기는?',
    required: false,
    options: ['처음', '비정기', '월 1회', '주 1회 이상'],
  },
  Q16: {
    id: 'Q16',
    type: 'single-select',
    section: 5,
    sectionName: '경제·지속 여건',
    text: '월 뷰티 관리 예산대는?',
    required: false,
    options: ['~5만', '5~15만', '15~30만', '30만원 이상'],
  },
  Q17: {
    id: 'Q17',
    type: 'single-select',
    section: 5,
    sectionName: '경제·지속 여건',
    text: '선호 방문 주기는?',
    required: false,
    options: ['주 1회', '격주', '월 1회', '비정기'],
  },
  Q18: {
    id: 'Q18',
    type: 'multi-select',
    section: 5,
    sectionName: '경제·지속 여건',
    text: '방문 가능 시간대는?',
    required: false,
    options: ['평일 오전', '평일 오후', '주말 오전', '주말 오후'],
  },
  Q19: {
    id: 'Q19',
    type: 'single-select',
    section: 6,
    sectionName: '이력·유전',
    text: '자가 인식 피부타입은?',
    required: false,
    options: ['지성', '건성', '복합', '중성', '민감'],
  },
  Q20: {
    id: 'Q20',
    type: 'multi-select',
    section: 6,
    sectionName: '이력·유전',
    text: '과거 트러블·이력은?',
    required: false,
    options: ['여드름', '색소·기미', '홍조·주사', '아토피·건선', '흉터', '없음'],
  },
  Q21: {
    id: 'Q21',
    type: 'single-select',
    section: 6,
    sectionName: '이력·유전',
    text: '알레르기·성분 이상반응 이력은?',
    required: false,
    options: ['있음', '없음', '모름'],
  },
  Q22: {
    id: 'Q22',
    type: 'multi-select',
    section: 6,
    sectionName: '이력·유전',
    text: '피부 관련 가족력은?',
    required: false,
    options: ['색소·기미', '조기 노화·주름', '홍조', '민감·아토피', '해당 없음'],
  },
  Q23: {
    id: 'Q23',
    type: 'single-select',
    section: 6,
    sectionName: '이력·유전',
    text: '현재 임신/수유 중이신가요?',
    required: false,
    sensitive: true,
    options: ['예', '아니오'],
  },
};

export interface StepConfig {
  questionIds: string[];
  sectionNumber: number;
  sectionName: string;
}

export const questionSteps: StepConfig[] = [
  { questionIds: ['Q1'], sectionNumber: 1, sectionName: '목표' },
  { questionIds: ['Q2', 'Q3'], sectionNumber: 1, sectionName: '목표' },
  { questionIds: ['Q4', 'Q5'], sectionNumber: 2, sectionName: '생활·환경' },
  { questionIds: ['Q6', 'Q9'], sectionNumber: 2, sectionName: '생활·환경' },
  { questionIds: ['Q7', 'Q8'], sectionNumber: 2, sectionName: '생활·환경' },
  { questionIds: ['Q10'], sectionNumber: 3, sectionName: '직업군' },
  { questionIds: ['Q11'], sectionNumber: 3, sectionName: '직업군' },
  { questionIds: ['Q12', 'Q13'], sectionNumber: 4, sectionName: '관리 패턴' },
  { questionIds: ['Q14'], sectionNumber: 4, sectionName: '관리 패턴' },
  { questionIds: ['Q15', 'Q16'], sectionNumber: 4, sectionName: '관리 패턴' },
  { questionIds: ['Q17', 'Q18'], sectionNumber: 5, sectionName: '경제·지속 여건' },
  { questionIds: ['Q19', 'Q21'], sectionNumber: 6, sectionName: '이력·유전' },
  { questionIds: ['Q20'], sectionNumber: 6, sectionName: '이력·유전' },
  { questionIds: ['Q22', 'Q23'], sectionNumber: 6, sectionName: '이력·유전' },
];

export const TOTAL_QUESTIONS = 23;

export const consentItems = [
  { id: 'consent_privacy', key: 'privacy', label: '개인정보 수집·이용 동의', required: true },
  { id: 'consent_photo', key: 'photo', label: '피부 사진 촬영·저장 동의', required: true },
  { id: 'consent_ai', key: 'aiTraining', label: 'AI 학습 활용 동의', required: false },
  { id: 'consent_marketing', key: 'marketing', label: '마케팅·재방문 알림 수신', required: false },
];